/* Built In Imports */

/* External Imports */
import { Box, Button, Flex, Image, Link, Text } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import StructuredTextContent from '@components/UI/StructuredTextContent';
import HeadComponent from '@components/Utility/HeadComponent';
import { getLocale } from '@components/Utility/Shared/SharedService';
import { refineUrlDomain } from '@components/Utility/utils';
import config from '@config';

/* Services */
import {
  fetchFooterData,
  filterBuildUrls,
  getLatestBuild,
  getMYYPageLandingPaths,
} from 'services/commonService';

/**
 * @param {string} region - Current User Region
 * @param {string} language - Current User Language
 * @param {string} pageData - Maha Yoga Yagna Landing Page Data
 * @returns
 */
export default function index({ pageData, region, language }) {
  const renderMYYSection = () => {
    return (
      <Box
        w="100%"
        float="left"
        pos="relative"
        bgColor={'#000'}
        fontFamily="FedraSansStd-book"
        p={{ lg: '30px', md: '30px', base: '15px' }}
      >
        <Box
          color="#fff"
          w={{ lg: '60%', md: '60%', base: '100%' }}
          m="0 auto"
          textAlign={{ lg: 'center', md: 'center', base: 'left' }}
        >
          <Text
            color="#FFA735"
            fontSize={{ base: '40px', lg: '40px', md: '40px' }}
            fontFamily="FedraSansStd-A-medium"
            fontWeight="normal"
            as="h1"
            width={{ base: '80%', lg: '100%' }}
          >
            <a name="registernow" />
            {pageData.body[0]?.sectionContent[1]?.titleText}
          </Text>
          <Text fontSize="16px" className="myy_banner">
            {StructuredTextContent(pageData.body[0]?.sectionContent[2]?.body)}
          </Text>
          <Box
            width={{ lg: '690px', md: '100%', base: '100%' }}
            fontFamily="FedraSansStd-book"
            fontWeight="normal"
            fontSize={{ base: '16px', lg: '16px', md: '16px' }}
            lineHeight={{ base: '23px', lg: '23px', md: '23px' }}
            textAlign={{ lg: 'center', md: 'center', base: 'left' }}
            color="#ffffff"
            m={{
              lg: '20px auto',
              md: '20px auto',
              base: '15px auto 20px auto',
            }}
          >
            {StructuredTextContent(pageData.body[0]?.sectionContent[3]?.body)}
          </Box>
          <Box
            alignItems="center"
            textAlign="center"
            mt={{ lg: '20px', base: '40px', md: '20px' }}
            mr={{ lg: '0', md: '0', base: '5%' }}
          >
            <Button
              background="#cf4520"
              color="#ffffff"
              fontSize={{
                base: '16px',
                sm: '16px',
                md: '16px',
                lg: '16px',
              }}
              padding={{ base: '21px 43px', sm: '21px 43px' }}
              margin={{
                base: '0 0 20px 0',
                lg: '20px 0 20px 0',
                sm: '0 0 20px 0',
              }}
              borderRadius="4px"
              fontFamily="FedraSansStd-medium,sans-serif"
              _hover={{
                border: 'none',
                color: '#ffffff',
              }}
              _active={{
                border: 'none',
                background: '#000054',
              }}
              border="none"
              fontWeight="normal"
              width="192px"
              height="48px"
            >
              {pageData.body[0]?.sectionContent[4]?.linkUrl != '' ? (
                <>
                  <Link
                    // href={pageData.body[0]?.sectionContent[4]?.linkUrl}
                    href={refineUrlDomain(
                      pageData.body[0]?.sectionContent[4]?.linkUrl,
                      region,
                      language
                    )}
                    target="_blank"
                  >
                    {pageData.body[0]?.sectionContent[4]?.buttonText}
                  </Link>
                </>
              ) : (
                <>{pageData.body[0]?.sectionContent[4]?.buttonText}</>
              )}
            </Button>
            <Text
              fontFamily="FedraSansStd-book"
              fontWeight="normal"
              fontSize={{ base: '16px', lg: '16px', md: '16px' }}
              lineHeight={{ base: '23px', lg: '23px', md: '23px' }}
              color="#ffffff"
              textAlign={{ lg: 'center', md: 'center', base: 'center' }}
              className="myy_banner"
              mt={{ base: '5px', lg: '5px' }}
            >
              {pageData.body[0]?.sectionContent[5]?.text}
            </Text>
            <Button
              background="transparent"
              color="#faf7f0"
              fontSize={{
                base: '16px',
                sm: '16px',
                md: '18px',
                lg: '16px',
              }}
              padding={{ base: '21px 43px', sm: '21px 43px' }}
              margin={{ base: '10px 0', sm: '10px 0' }}
              borderRadius="4px"
              fontFamily="FedraSansStd-medium,sans-serif"
              _hover={{
                border: '1px solid #ffffff',
                color: '#ffffff',
              }}
              _active={{
                border: 'none',
                background: '#000054',
              }}
              border="1px solid #ffffff"
              fontWeight="normal"
              width="192px"
              height="48px"
            >
              {pageData.body[0]?.sectionContent[6]?.linkUrl != '' ? (
                <>
                  <Link
                    // href={pageData.body[0]?.sectionContent[6]?.linkUrl}
                    href={refineUrlDomain(
                      pageData.body[0]?.sectionContent[6]?.linkUrl,
                      region,
                      language
                    )}
                    target="_blank"
                  >
                    {pageData.body[0]?.sectionContent[6]?.buttonText}
                  </Link>
                </>
              ) : (
                <>{pageData.body[0]?.sectionContent[6]?.buttonText}</>
              )}
            </Button>
          </Box>
        </Box>
        <Box
          color="#fff"
          w={{ lg: '70%', md: '70%', base: '100%' }}
          m="0 auto"
          textAlign="center"
          pt={{ lg: '30px', md: '30px', base: '30px' }}
        >
          <Text color="#FFA735" fontSize={{ base: '28px', lg: '28px' }} as="h2">
            {pageData.body[1]?.sectionContent[0]?.title[0].titleText}
          </Text>
          <Flex
            justifyContent="space-between"
            flexDirection={{ base: 'column', md: 'row', lg: 'row' }}
            m="30px auto"
            textAlign={{ base: 'left', md: 'center', lg: 'center' }}
            width={{ base: '90%', lg: '845px', md: '100%' }}
            fontSize={{ lg: '16px', md: '16px', base: '16px' }}
          >
            {pageData.body[1]?.sectionContent[0]?.simpleCards.map(
              (data, index) => {
                return (
                  <Box
                    key={index}
                    pb="20px"
                    display="flex"
                    flexDirection={{ base: 'row', md: 'column', lg: 'column' }}
                    textAlign={{ base: 'left', md: 'center', lg: 'center' }}
                    width={{ lg: '190px', md: '190px', base: '100%' }}
                  >
                    <Box height={{ lg: '94px', md: '94px', base: '100%' }}>
                      <Image
                        w={{ base: '50px', md: '80px', lg: '80px' }}
                        src={data.rectangularImage.url}
                        alt={data.rectangularImage.alt}
                        title={data.rectangularImage.title}
                      />
                    </Box>
                    <Text
                      pt={{ base: '0', lg: '15px', md: '15px' }}
                      pl={{ base: '25px', lg: 0, md: 0 }}
                    >
                      {data.title}
                    </Text>
                  </Box>
                );
              }
            )}
          </Flex>
        </Box>
      </Box>
    );
  };

  return pageData ? (
    <>
      <HeadComponent
        data={pageData?._seoMetaTags}
        availableLocals={pageData?.availableLocales}
      />
      <Box w="100%" float="left" pos="relative" fontFamily="FedraSansStd-book">
        <Box
          float="left"
          w="100%"
          pos="relative"
          background=" rgba(0, 0, 0, 0.7)"
        >
          <Box
            p="18px 20px 18px 20px"
            bgColor="#000000"
            opacity="0.8"
            fontSize="14px"
          >
            <Link href="/in/en/" color="#fff">
              <Image
                mr="20px"
                alt="arrow"
                title="arrow"
                src="https://static.sadhguru.org/d/46272/1637315968-leftarrow.png"
              />
              Back to Home
            </Link>
          </Box>
          <Box
            background={{
              md: `url(${pageData.body[0]?.sectionContent[0]?.image?.url}) no-repeat !important`,
              lg: `url(${pageData.body[0]?.sectionContent[0]?.image?.url}) no-repeat !important`,
              base: `url(${pageData.body[0]?.sectionContent[0]?.mobileImage?.url}) no-repeat !important`,
            }}
            backgroundSize={{ base: 'cover !important' }}
            h={{ md: '560px', lg: '560px', base: '330px' }}
            id="bannerimage"
            bgColor="#000000 !important"
          >
            <Box
              textAlign="center"
              pt={{ md: '30px', lg: '30px', base: '20px' }}
            ></Box>
          </Box>
        </Box>
        {renderMYYSection()}
      </Box>
      <style global jsx>{`
        .myy_banner mark {
          background-color: transparent;
          color: #ffa735;
          display: block;
        }
        #bannerimage {
          background-position-x: center !important;
          background-color: #000000 !important;
        }
        @media screen and (max-width: 480px) {
          bannerimage {
            background-size: cover !important;
          }
        }
      `}</style>
    </>
  ) : <></>;
}

export const getStaticPaths = async () => {
  let MYYPaths = [];
  // : [];

  if (process.env?.NEXT_PUBLIC_BUILD_ID) {
    const data = await getLatestBuild(process.env.NEXT_PUBLIC_BUILD_ID);
    MYYPaths = filterBuildUrls('', 'lvl0', '/maha-yoga-yagna', '', data);
  } else if (MYYPaths?.length < 1 && config.BUILD_URLS?.LANDING_PAGES?.MYY) {
    MYYPaths = await getMYYPageLandingPaths('lvl0', '/maha-yoga-yagna');
  }
  return {
    paths: MYYPaths,
    fallback: false,
  };
};

export const getStaticProps = async ({
  params: { region = 'in', language = 'en' },
  // req,
}) => {
  const footerData = await fetchFooterData(
    getLocale(region, language),
    'isofooter'
  );
  return {
    props: {
      headerTopMenuData: null,
      region: region,
      language: language,
      pageData: null,
      footerData: footerData?.data || null,
      page: 'Maha yoga yagna',
      headerVisible: false,
    },
  };
};
